// 横向条形图（增长来源 / 关键词 TOP / 关注者排行）
import { formatNumber } from '@/lib/utils'

export interface BarDatum {
  name: string
  value: number
}

interface Props {
  data: BarDatum[]
  maxItems?: number
  className?: string
}

export default function SourceBar({ data, maxItems = 10, className }: Props) {
  const items = data.slice(0, maxItems)
  const max = Math.max(...items.map((d) => d.value), 1)

  return (
    <div className={className}>
      <ul className="flex flex-col gap-3">
        {items.map((d, i) => {
          const pct = (d.value / max) * 100
          const top3 = i < 3
          return (
            <li key={d.name} className="grid grid-cols-[1fr_5fr_auto] items-center gap-3 group">
              <span
                className={`text-sm truncate ${top3 ? 'text-ink-900 font-semibold' : 'text-ink-700'}`}
                title={d.name}
              >
                {d.name}
              </span>
              <div className="h-3 rounded-sm bg-ink-100 overflow-hidden">
                <div
                  className={`h-full rounded-sm transition-all duration-300 ${
                    top3 ? 'bg-primary-500 group-hover:bg-primary-600' : 'bg-primary-300 group-hover:bg-primary-400'
                  }`}
                  style={{ width: `${pct}%` }}
                  aria-label={`${d.name} ${pct.toFixed(0)}%`}
                />
              </div>
              <span
                className={`text-sm num text-right w-20 ${top3 ? 'text-ink-900 font-semibold' : 'text-ink-500'}`}
              >
                {formatNumber(d.value)}
              </span>
            </li>
          )
        })}
        {items.length === 0 && (
          <li className="text-sm text-ink-300 text-center py-6">暂无数据</li>
        )}
      </ul>
    </div>
  )
}
